

const FourOFour = () => {
    return (
        <div>
            <h1>Sorry, No Page Found.</h1>
            <button><a href="/">Go Back Home</a></button>
        </div>
    )
}

export default FourOFour;